/**
 * Shared color mapping utilities for badges
 */

import type { IssueSeverity, IssueTag } from '../domain'

type BadgeColor = 'brand' | 'danger' | 'important' | 'informative' | 'severe' | 'subtle' | 'success' | 'warning'

export const SEVERITY_BADGE_COLORS: Record<IssueSeverity, BadgeColor> = {
  critical: 'danger',
  high: 'danger',
  medium: 'warning',
  low: 'subtle',
}

export function getSeverityBadgeColor(severity: IssueSeverity): BadgeColor {
  return SEVERITY_BADGE_COLORS[severity]
}

export function mapTagColorToBadge(color: IssueTag['color']): BadgeColor {
  switch (color) {
    case 'brand':
      return 'brand'
    case 'danger':
      return 'danger'
    case 'warning':
      return 'warning'
    case 'success':
      return 'success'
    case 'informative':
      return 'informative'
    case 'subtle':
      return 'subtle'
    default:
      return 'subtle'
  }
}
